import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useSession } from "../../../hooks/useSession/useSession";
import { LoadingIndicator } from "../LoadingIndicator/LoadingIndicator";

export const Logout = () => {
    const { signOut, isAuthenticated } = useSession();
    const navigate = useNavigate();
    const isLoggingOut = useRef(false);

    useEffect(() => {
        if (isAuthenticated) {
            isLoggingOut.current = true;
            signOut().catch(() => navigate("/"));
        } else if (isAuthenticated === false && !isLoggingOut.current) {
            navigate("/");
        }
    }, [isAuthenticated, signOut, navigate]);

    return <LoadingIndicator logo />;
};
